import WorkOrderWeather
from '@/App/WorkOrders/EditWorkOrder/@Components/WorkOrderWeather/WorkOrderWeather.vue';

export default WorkOrderWeather;
